// Collapsed state is kept per line key, otherwise every cart drawer re-render would expand the list again
class BundleComponents extends HTMLElement {
  connectedCallback() {
    this.toggleButton = this.querySelector('.bundle-components__toggle');
    this.list = this.querySelector('.bundle-components__list');
    if (!this.toggleButton) return;

    this.applyState(!this.readCollapsed());

    this.onToggleClick = () => {
      const expanded = this.toggleButton.getAttribute('aria-expanded') !== 'true';
      this.applyState(expanded);
      this.writeCollapsed(!expanded);
    };

    this.toggleButton.addEventListener('click', this.onToggleClick);

    if (this.list && 'ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => this.updateOffset());
      this.resizeObserver.observe(this.list);
    }
  }

  disconnectedCallback() {
    this.toggleButton?.removeEventListener('click', this.onToggleClick);
    this.resizeObserver?.disconnect();
  }

  // On /cart quantity and total live in other cells of the row
  get row() {
    return this.closest('tr') || this.closest('.line-item, .quick-buy-drawer__variant');
  }

  updateOffset() {
    const row = this.row;
    if (!row || !this.list) return;

    const height = this.list.hidden
      ? 0
      : this.list.offsetHeight + parseFloat(getComputedStyle(this.list).marginTop || 0);

    row.style.setProperty('--bundle-components-offset', `${height}px`);
  }

  get storageKey() {
    const lineKey = this.dataset.lineKey;
    return lineKey ? `bundle-collapsed:${lineKey}` : null;
  }

  applyState(expanded) {
    const list = this.list;
    const label = this.querySelector('.bundle-components__label');

    this.toggleButton.setAttribute('aria-expanded', String(expanded));
    if (list) list.hidden = !expanded;

    const text = expanded ? this.dataset.labelHide : this.dataset.labelShow;
    if (label && text) label.textContent = text;

    this.updateOffset();
  }

  readCollapsed() {
    if (!this.storageKey) return false;

    try {
      return localStorage.getItem(this.storageKey) === '1';
    } catch (error) {
      return false;
    }
  }

  writeCollapsed(collapsed) {
    if (!this.storageKey) return;

    try {
      if (collapsed) {
        localStorage.setItem(this.storageKey, '1');
      } else {
        localStorage.removeItem(this.storageKey);
      }
    } catch (error) {
      // Storage blocked: the list just stays expanded
    }
  }
}

if (!customElements.get('bundle-components')) {
  customElements.define('bundle-components', BundleComponents);
}
